import restAPI from '@/utils/rest-api'

export default {
    isValid(phone) {
        return restAPI.get(`/referrers/is-valid/mobile/${phone}`)
    }
}
